import superagent from 'superagent';
import pickBy from "lodash/pickBy";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";

import { getPromise, postPromise, deletePromise, putPromise, wrapResolveRejectWithHeaders, postForm } from './request';
import {getFullUrl, isValidValue} from '../util/pure_functions/utils';

function paramsWithCommentRealmId(params) {
  return pickBy(Object.assign(params || {}, {comment_realm_id: global.commentRealmId}), isValidValue);
}

function accountLogin() {
  let config = talktype.config || metype.config,
      configurations = (config.account && config.account['configurations']) || '';
  return configurations && configurations.find((config) => config.name == 'account_login');
}

function currentAccountUserJWT() {
  let currentAccountUser =  metype.currentUser || talktype.currentUser;
  if(!isEmpty(currentAccountUser) && currentAccountUser.jwt){
    return currentAccountUser.jwt;
  }
}

function paramsWithJWT(params={}) {
  return Object.assign(params, { jwt: currentAccountUserJWT() });
}

export function indexAuthors(accountId, pageId, params) {
  return getPromise(getFullUrl(`api/v1/accounts/${accountId}/pages/${pageId}/authors.json`), paramsWithCommentRealmId(params));
}

export function trendingStories(page, perPage, accountId) {
  return getPromise(getFullUrl(`api/v1/pages/engagement?account_id=${accountId}&limit=${perPage}&offset=${page}`));
}

export function indexComments(accountId, pageId, sortOrder, parent_comments_limit='4', parent_comments_offset='0') {
  const commentRealmId = global.commentRealmId;
  if (isValidValue(commentRealmId))
  return getPromise(getFullUrl(`api/v1/accounts/${accountId}/pages/${pageId}/comments.json?parent_comments_limit=${parent_comments_limit}&parent_comments_offset=${parent_comments_offset}&sort_order=${sortOrder}&child_comments_sort_order=asc&comment_realm_id=${global.commentRealmId}`));
  else
  return getPromise(getFullUrl(`api/v1/accounts/${accountId}/pages/${pageId}/comments.json?parent_comments_limit=${parent_comments_limit}&parent_comments_offset=${parent_comments_offset}&sort_order=${sortOrder}&child_comments_sort_order=asc`));
n}

export function indexFeed(accountId, page, perPage) {
  return getPromise(getFullUrl(`api/v1/accounts/${accountId}?page=${page}&per_page=${perPage}`));
}

export function createComment(accountId, pageId, comment) {
  let params = { comment: comment };
  if(accountLogin() && currentAccountUserJWT()) {
    params = paramsWithJWT(params);
  };
  return postPromise(getFullUrl(`api/v1/accounts/${accountId}/pages/${pageId}/comments.json`), paramsWithCommentRealmId(params));
}

export function signupUser(params) {
  return postForm(getFullUrl("api/v1/users/sign_up"), params)
}

export function signInUser(params) {
  return postForm(getFullUrl("api/v1/users/sign_in"), params)
}

export function authenticateOtp(params) {
  return postPromise(getFullUrl("api/v1/users/authenticate_otp"), params)
}

export function resetPasswordOtp(params) {
  return postPromise(getFullUrl("api/v1/users/password_reset_otp"), params)
}

export function verifyPasswordResetOtp(params) {
  return postPromise(getFullUrl("api/v1/users/verify_password_otp"), params)
}

export function regenerateOtp(params) {
  return postPromise(getFullUrl("api/v1/users/regenerate_otp"), params)
}

export function resetPassword(params) {
  return putPromise(getFullUrl("api/v1/users/reset_password"), params)
}

export function revokeAccess(accountId, userId, params = {}) {
  return deletePromise(`/api/v1/admin/accounts/${accountId}/users/${userId}`, params);
}

export function getPersonalizedFeed(userId, params = {}) {
  return getPromise(getFullUrl(`api/v1/users/${userId}/comment_realms`), params);
}

export function updateComment(accountId, page_id, commentId, comment) {
  let params = { comment: comment }
  if(accountLogin() && currentAccountUserJWT()) {
    params = paramsWithJWT(params);
  };
  return putPromise(getFullUrl(`api/v1/accounts/${accountId}/pages/${page_id}/comments/${commentId}`), paramsWithCommentRealmId(params));
}

export function addUpdatePageMetadata(accountId, pageId, metadata, host) {
  let params = { 'page': { 'metadata': metadata, 'page_id': pageId} };

  return postPromise(getFullUrl(`api/v1/accounts/${accountId}/pages`, host), params);
}

export function getPage(accountId, pageId, host) {
  return getPromise(getFullUrl(`api/v1/accounts/${accountId}/pages/${pageId}`, host));
}

export function reactOnPage(accountId, reactionId, pageId) {
  var params = {'account_id': accountId};
  if(accountLogin() && currentAccountUserJWT()) {
    params = paramsWithJWT(params);
  }
  return postPromise(getFullUrl(`api/v1/reactions/${reactionId}/pages/${pageId}/activity`), params);
}

export function unReactOnPage(accountId, reactionId, pageId) {
  var params = {'account_id': accountId};
  if(accountLogin() && currentAccountUserJWT()) {
    params = paramsWithJWT(params);
  }
  return deletePromise(getFullUrl(`api/v1/reactions/${reactionId}/pages/${pageId}/activity`), params);
}

export function pageReactionsOfUser(accountId, reactionId) {
  var params = {'account_id': accountId};
  if(accountLogin() && currentAccountUserJWT()) {
    params = paramsWithJWT(params);
  }
  return getPromise(getFullUrl(`api/v1/reactions/${reactionId}/user_page_reactions`), params);
}

export function totalReactionsOfPage(accountId, reactionId, pageId) {
  var params = {'account_id': accountId};
  if(accountLogin() && currentAccountUserJWT()) {
    params = paramsWithJWT(params);
  }
  return getPromise(getFullUrl(`api/v1/reactions/${reactionId}/pages/${pageId}/reaction_counts`), params)
}

export function reactOnComment(reactionId, commentId) {
  var api = `api/v1/reactions/${reactionId}/comments/${commentId}/activity`;
  if(accountLogin() && currentAccountUserJWT()) {
    var params = paramsWithJWT();
    api = `/api/v1/accounts/${global.metypeAccountId}/reactions/${reactionId}/comments/${commentId}/activity`
  }
  return postPromise(getFullUrl(api), paramsWithCommentRealmId(params));
}

export function unReactOnComment(reactionId, commentId) {
  var api = `api/v1/reactions/${reactionId}/comments/${commentId}/activity`;
  if(accountLogin() && currentAccountUserJWT()) {
    var params = paramsWithJWT();
    api = `/api/v1/accounts/${global.metypeAccountId}/reactions/${reactionId}/comments/${commentId}/activity`
  }
  return deletePromise(getFullUrl(api), paramsWithCommentRealmId(params));
}

export function reactionsByUser(reactionId, commentId) {
  if((commentId && commentId.length > 0 && isValidValue(reactionId))) {
    var api = `api/v1/reactions/${reactionId}/comments/${commentId}/activity`;
    if(accountLogin() && currentAccountUserJWT()) {
      var params = paramsWithJWT();
      api = `/api/v1/accounts/${global.metypeAccountId}/reactions/${reactionId}/comments/${commentId}/activity`
    }
    return getPromise(api, paramsWithCommentRealmId(params));
  }
}

export function hideComment(accountId, pageId, commentId) {
  if(accountLogin() && currentAccountUserJWT()) {
    var params = paramsWithJWT();
  }
  return postPromise(getFullUrl(`api/v1/accounts/${accountId}/pages/${pageId}/comments/${commentId}/hide.json`), paramsWithCommentRealmId(params));
}

export function deleteComment(commentIds, accountId) {
  if (commentIds.length) {
    return deletePromise(getFullUrl(`/api/v1/admin/comments`), {'comment_ids': commentIds, 'account_id': accountId});
  }
}

export function authCallback(provider, params) {
  return getPromise(getFullUrl(`users/auth/${provider}/callback`), params);
}

export function postAuthCallback(provider, params) {
  return postPromise(getFullUrl(`users/auth/${provider}/callback?code=${params.code}&redirect_uri=postmessage`), params);
}

export function submitStory(accountId, contribution) {
  var params = {
    contribution: {...contribution, html: btoa(encodeURIComponent(contribution.html)) }
  };
  if(accountLogin() && currentAccountUserJWT()) {
    params = paramsWithJWT(params);
  };
  return postPromise(getFullUrl(`api/v1/accounts/${accountId}/contributions`), params);
}

export function currentUser() {
  const params = {};
  if (global.metypeAccountId) {
    params.account_id = global.metypeAccountId
  }
  return getPromise(getFullUrl(`api/v1/current_user.json`), params);
}

export function currentUserOfAccount(jwt) {
  let accountId = global.metypeAccountId
  return getPromise(getFullUrl(`api/v1/accounts/${accountId}/current_user.json?jwt=${jwt}`));
}

export function currentAccountInfo(accountId){
    return getPromise(getFullUrl(`api/v1/accounts/${accountId}`));
}

export function checkDomainValidity(accountId, domain, host) {
  return getPromise(getFullUrl(`api/v1/accounts/${accountId}/domain_validity?domain=${domain}`, host));
}

export function logOutUser() {
  return deletePromise(getFullUrl(`api/v1/current_user.json`));
}

export function sign(fileName, mimeType) {
  return getPromise(getFullUrl(`api/v1/sign?file_name=${fileName}&mime_type=${mimeType}`));
}

export function fetchNotifications(sortOrder, accountId, page) {
  var params = {'order_by': sortOrder, 'account_id': accountId, 'page': page};
  if(accountLogin() && currentAccountUserJWT()) {
    params = paramsWithJWT(params);
  }
  return getPromise(getFullUrl(`api/v1/notifications`), params);
}

export function readNotifications(notification_id) {
  var params = {'notification_id': notification_id};
  if(accountLogin() && currentAccountUserJWT()) {
    params = Object.assign(paramsWithJWT(params), {'account_id': global.metypeAccountId});
  }
  return postPromise(`api/v1/notifications/read`, params);
}

export function upload(url, formData) {
  return new Promise((resolve, reject) => {
    const request = superagent.post(url),
          keys = ["key","success_action_status","acl","policy","Content-Type","x-amz-credential","x-amz-algorithm","x-amz-date","x-amz-signature","file"];
    keys.forEach(function(key) {
      request.field(key, formData[key]);
    });
    request.end(wrapResolveRejectWithHeaders(resolve, reject));
  })
}

export function revokeApplicationAccess(applicationId) {
  return deletePromise(getFullUrl(`api/v1/authorized_applications/${applicationId}`));
}

export function accountConfig() {
  return getPromise(getFullUrl(`api/v1/accounts/${global.metypeAccountId}/config`));
}



// WEBPACK FOOTER //
// ./app/javascript/gateway/api.js